import * as req from 'api/actions';
import * as c from './constants';

export const dummy = () => {};

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    'api/v1/bpls/administrator/reports/pre_registrations',
    payload,
    callback
  );

export const upload = (payload = {}, callback) =>
  req.upload(
    c.UPLOAD,
    'api/v1/administrators/rpt_billing_imports/upload_csv',
    payload,
    callback
  );

export const getFireList = (payload = {}, callback) =>
  req.list(
    c.FIRE_LIST,
    'api/v1/bpls/administrator/reports/fire_safety',
    payload,
    callback
  );

export const getAmnestyList = (payload = {}, callback) =>
  req.list(
    c.AMNESTY_LIST,
    'api/v1/bpls/administrator/reports/tax_amnesty',
    payload,
    callback
  );
